import {checkGA, error} from 'methods/utils';
import YandexEcommerce from 'components/yandex/ecommerce';
import metrikaCollector, {
    collectGoogleEvent,
    collectRetail,
    collectYandexReachGoal,
} from 'components/metrika';

function HotelMetrika() {
    const $hotelData = document.querySelector('.js-hotelData');
    const hotelID    = $hotelData ? +$hotelData.dataset.hotel_id : 0;
    const $ecommerce = document.querySelector('.js-ecommerce');

    // отправка метрики yandex/google/retail
    this.sendOrderMetrics = function(type, $element = null) {
        if (!type || type < 1 || type > 3) {
            return error({
                message: 'window.sendOrderMetrics type вне границ 1..3',
            });
        }

        if (!$hotelData) {
            return error({
                message: 'window.sendOrderMetrics $hotelData не объявлен',
            });
        }

        if (!hotelID) {
            return error({
                message: 'window.sendOrderMetrics hotelID не объявлен',
            });
        }

        switch (type) {
            case 1: // отель
                checkGA(() => {
                    ga('send', 'event', {
                        eventCategory: 'Hotel',
                        eventAction: 'open_hotel_order_page',
                    });
                    ga('send', 'pageview', '/virtual/hotel/open_hotel_order_page/');
                    collectGoogleEvent(metrikaCollector, 'Hotel', 'open_hotel_order_page', {
                        page: '/virtual/hotel/open_hotel_order_page/',
                    });
                });

                if (typeof yaCounter46243086 !== "undefined") {
                    yaCounter46243086.reachGoal('open_hotel_order_page');
                    yaCounter46243086.hit('/virtual/hotel/open_hotel_order_page/');
                    collectYandexReachGoal(metrikaCollector, 'open_hotel_order_page', {
                        data: {hit: '/virtual/hotel/open_hotel_order_page/'},
                    });
                }

                break;
            case 2: // номер
                checkGA(() => {
                    ga('send', 'event', {
                        eventCategory: 'Hotel',
                        eventAction: 'open_apartment_order_page',
                    });
                    collectGoogleEvent(metrikaCollector, 'Hotel', 'open_apartment_order_page');
                });

                if (typeof yaCounter46243086 !== "undefined") {
                    yaCounter46243086.reachGoal('open_apartment_order_page');
                    collectYandexReachGoal(metrikaCollector, 'open_apartment_order_page');
                }

                break;
            case 3: // модалка номера
                checkGA(() => {
                    ga('send', 'event', {
                        eventCategory: 'Hotel',
                        eventAction: 'open_modal_order_page',
                    });
                    ga('send', 'pageview', '/virtual/hotel/open_modal_order_page/');
                    collectGoogleEvent(metrikaCollector, 'Hotel', 'open_modal_order_page', {
                        page: '/virtual/hotel/open_modal_order_page/',
                    });
                });

                if (typeof yaCounter46243086 !== "undefined") {
                    yaCounter46243086.reachGoal('open_modal_order_page');
                    yaCounter46243086.hit('/virtual/hotel/open_modal_order_page/');
                    collectYandexReachGoal(metrikaCollector, 'open_modal_order_page', {
                        data: {hit: '/virtual/hotel/open_modal_order_page/'},
                    });
                }
                break;
        }

        // добавление товара в корзину
        if ($ecommerce) {
            let json;

            try {
                json = JSON.parse($ecommerce.innerHTML);
            } catch(e) {
                console.error(e);
            }

            if ($element) {
                // стоимость с кнопки
                if ($element.dataset.price) {
                    json.price = $element.dataset.price;
                }

                // номер с кнопки
                if ($element.dataset.apartment_id && $element.dataset.apartment_title) {
                    json.variant = `${$element.dataset.apartment_title} (${$element.dataset.apartment_id})`;
                }
            }

            if (json) {
                json.list = document.referrer;

                YandexEcommerce.push('add', [json]);
            }
        }

        checkGA(() => {
            ga('send', 'event', {
                eventCategory: 'Hotel',
                eventAction: 'open_order_page',
            });
            collectGoogleEvent(metrikaCollector, 'Hotel', 'open_order_page');
        });

        if (typeof yaCounter46243086 !== "undefined") {
            yaCounter46243086.reachGoal('open_order_page');
            collectYandexReachGoal(metrikaCollector, 'open_order_page');
        }

        (window['rrApiOnReady'] = window['rrApiOnReady'] || []).push(function() {
            try {
                rrApi.addToBasket(hotelID);
            } catch(e) {}
            collectRetail(metrikaCollector, 'addToBasket', {data: {id: hotelID}});
        });

        return true;
    }

    this._pageView = function() {
        let formData = new FormData();
            formData.append('hotel_id', hotelID);

        fetch('/hotels/increment_view_counter/', {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
        }).then(response => response.json());

        // отслеживание просмотра карточки отеля
        checkGA(() => {
            ga('send', 'event', {
                eventCategory: 'Hotel',
                eventAction: 'view',
            });
            collectGoogleEvent(metrikaCollector, 'Hotel', 'view');
        });

        if (typeof yaCounter46243086 !== "undefined") {
            yaCounter46243086.reachGoal('hotel_view');
            collectYandexReachGoal(metrikaCollector, 'hotel_view');
        }

        (window['rrApiOnReady'] = window['rrApiOnReady'] || []).push(function() {
            try {
                rrApi.view(hotelID);
            } catch(e) {}
            collectRetail(metrikaCollector, 'view', {data: {id: hotelID}});
        });

        if ($ecommerce) {
            let json;

            try {
                json = JSON.parse($ecommerce.innerHTML);
            } catch(e) {
                console.error(e);
            }

            if (json) {
                json.list = document.referrer;

                YandexEcommerce.push('detail', [json]);
            }
        }
    }

    this.init = function() {
        // прокидываем метрику на кнопки
        window.sendOrderMetrics = this.sendOrderMetrics;

        // увеличиваем просмотры страница
        this._pageView();

        // метрика для кнопки whatsapp
        const $orderPlateWhatsapp = document.querySelector('.js-orderPlateWhatsapp');
        if ($orderPlateWhatsapp) {
            $orderPlateWhatsapp.addEventListener('click', function () {
                if (typeof yaCounter46243086 !== "undefined") {
                    yaCounter46243086.reachGoal('whatsapp_bro');
                    collectYandexReachGoal(metrikaCollector, 'whatsapp_bro');
                }
            });
        }

        // клик по кнопке "Другие объекты владельца" в меню
        let $hotelOwnerRedirect = document.querySelector('.js-hotelOwnerRedirect');
        if ($hotelOwnerRedirect) {
            $hotelOwnerRedirect.addEventListener('click', () => {
                if (typeof yaCounter46243086 !== "undefined") {
                    yaCounter46243086.reachGoal('owner');
                    collectYandexReachGoal(metrikaCollector, 'owner');
                }
            });
        }
    }
    this.init();
}

export default HotelMetrika;
